import React, { Component } from "react";
import { Select, MenuItem, IconButton, Grid } from "@material-ui/core";
import ComponentTemplate from "../../../Utilities/TemplateWrappers/ComponentTemplate";
import { getUsers, getToolboxTalks, getAllQualifications } from "./actions";
import { connect } from "react-redux";
import { Clear as RemoveIcon, Add as AddIcon } from "@material-ui/icons";
class JobPackAssigneesArrayList extends Component {
    constructor(props) {
        super(props);
        props.getUsers();
        props.getToolboxTalks();
        props.getAllQualifications();
        this.state = {
            profile: props.profile,
            edit: props.edit,
            input_rule: {
                applied_to: "all",
                rule_category: "qualifications",
                subject_id: "none",
                subject_name: "",
            },
            rules: [],
        };
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.profile !== this.props.profile) {
            this.setState({ profile: this.props.profile });
        }
        if (this.state.rules !== this.props.rules) {
            this.setState({ rules: this.props.rules });
        }
    }

    render() {
        const { users, toolboxtalks, qualifications } = this.props;
        const { rules, input_rule } = this.state;
        return (
            <ComponentTemplate
                isCollapsed={false}
                isCollapsable={true}
                label="Training Rules"
            >
                {users && toolboxtalks && (
                    <Grid container spacing={12}>
                        <Grid item sm={4} style={{ padding: 6 }}>
                            <Select
                                style={{ width: "100%" }}
                                value={input_rule.applied_to}
                                onChange={(event) => {
                                    let ru = input_rule;
                                    ru.applied_to = event.target.value;
                                    this.setState({
                                        input_rule: ru,
                                    });
                                }}
                            >
                                <MenuItem key={"all"} value={"all"}>
                                    Every Member Must Have a
                                </MenuItem>
                                <MenuItem key={"one"} value={"one"}>
                                    At Least One Member Must Have a
                                </MenuItem>
                            </Select>
                        </Grid>
                        <Grid item sm={3} style={{ padding: 6 }}>
                            <Select
                                style={{ width: "100%" }}
                                value={input_rule.rule_category}
                                onChange={(event) => {
                                    let ru = input_rule;
                                    ru.rule_category = event.target.value;
                                    ru.subject_id = "none";
                                    this.setState({
                                        input_rule: ru,
                                    });
                                }}
                            >
                                <MenuItem
                                    key={"qualifications"}
                                    value={"qualifications"}
                                >
                                    Qualifications
                                </MenuItem>
                                <MenuItem key={"toolboxes"} value={"toolboxes"}>
                                    Toolbox Talks
                                </MenuItem>
                            </Select>
                        </Grid>
                        <Grid item sm={3} style={{ padding: 6 }}>
                            <Select
                                style={{ width: "100%" }}
                                value={input_rule.subject_id}
                                onChange={(event) => {
                                    let ru = input_rule;
                                    ru.subject_id = event.target.value;
                                    this.setState({
                                        input_rule: ru,
                                    });
                                }}
                            >
                                <MenuItem key={"none"} value={"none"}>
                                    Select Option
                                </MenuItem>
                                {qualifications &&
                                    input_rule.rule_category ===
                                        "qualifications" &&
                                    qualifications.map((e) => {
                                        return (
                                            <MenuItem
                                                key={e.qualification_id}
                                                value={e.qualification_id}
                                            >
                                                {e.qualification_title}
                                            </MenuItem>
                                        );
                                    })}
                                {toolboxtalks &&
                                    input_rule.rule_category === "toolboxes" &&
                                    toolboxtalks.map((e) => {
                                        return (
                                            <MenuItem key={e.uid} value={e.uid}>
                                                {e.toolbox_topic}
                                            </MenuItem>
                                        );
                                    })}
                            </Select>
                        </Grid>
                        <Grid item sm={2} style={{ padding: 6 }}>
                            {" "}
                            <IconButton
                                style={{
                                    border: "1px solid green",
                                    color: " green",
                                }}
                                onClick={() => {
                                    let ru = rules;
                                    let name = "";
                                    if (input_rule.subject_id !== "none") {
                                        if (
                                            input_rule.rule_category ===
                                            "qualifications"
                                        ) {
                                            name = this.props.allQuals[
                                                input_rule.subject_id
                                            ]
                                                ? this.props.allQuals[
                                                      input_rule.subject_id
                                                  ].qualification_title
                                                : "";
                                        } else {
                                            name = this.props.allToolboxes[
                                                input_rule.subject_id
                                            ]
                                                ? this.props.allToolboxes[
                                                      input_rule.subject_id
                                                  ].profile.toolbox_topic
                                                : "";
                                        }
                                    }
                                    let new_rule = {
                                        applied_to: input_rule.applied_to,
                                        rule_category: input_rule.rule_category,
                                        subject_id: input_rule.subject_id,
                                        subject_name: name,
                                    };
                                    ru = [...ru, new_rule];
                                    if (input_rule.subject_id !== "none")
                                        this.props.setRules(ru);
                                }}
                            >
                                <AddIcon />
                            </IconButton>
                        </Grid>
                        <Grid item sm={4} style={{ padding: 6 }}>
                            <b>Applied To</b>
                        </Grid>
                        <Grid item sm={3} style={{ padding: 6 }}>
                            <b>Rule Category</b>
                        </Grid>
                        <Grid item sm={3} style={{ padding: 6 }}>
                            <b>Subject ID</b>
                        </Grid>
                        <Grid item sm={2} style={{ padding: 6 }}>
                            <b>Remove</b>
                        </Grid>
                        {rules &&
                            rules.map((r, i) => {
                                return (
                                    <React.Fragment>
                                        <Grid
                                            item
                                            sm={4}
                                            style={{ padding: 6 }}
                                        >
                                            {r.applied_to === "all"
                                                ? "Every Member must have a "
                                                : "At Least, one member must have a"}
                                        </Grid>
                                        <Grid
                                            item
                                            sm={3}
                                            style={{ padding: 6 }}
                                        >
                                            {r.rule_category ===
                                            "qualifications"
                                                ? "Qualification of"
                                                : "Toolbox Talk about"}
                                        </Grid>
                                        <Grid
                                            item
                                            sm={3}
                                            style={{ padding: 6 }}
                                        >
                                            {r.rule_category ===
                                                "qualifications" &&
                                            this.props.allQuals[r.subject_id]
                                                ? this.props.allQuals[
                                                      r.subject_id
                                                  ].qualification_title
                                                : ""}
                                            {r.rule_category !==
                                                "qualifications" &&
                                            this.props.allToolboxes[
                                                r.subject_id
                                            ]
                                                ? this.props.allToolboxes[
                                                      r.subject_id
                                                  ].profile.toolbox_topic
                                                : ""}
                                        </Grid>
                                        <Grid
                                            item
                                            sm={2}
                                            style={{ padding: 6 }}
                                        >
                                            <IconButton
                                                style={{
                                                    border: "1px solid red",
                                                    color: "red",
                                                }}
                                                onClick={() => {
                                                    let ru = rules;
                                                    ru.splice(i, 1);

                                                    this.props.setRules(ru);
                                                }}
                                            >
                                                <RemoveIcon />
                                            </IconButton>
                                        </Grid>
                                    </React.Fragment>
                                );
                            })}
                    </Grid>
                )}
            </ComponentTemplate>
        );
    }
}
export default connect(
    (store, props) => {
        const { selectors } = props;
        const {
            selectUserInfo,
            selectToolboxTalks,
            selectQualifications,
            selectAllToolboxes,
            selectAllQualifications,
        } = selectors;
        return {
            users: selectUserInfo(store),
            toolboxtalks: selectToolboxTalks(store),
            qualifications: selectQualifications(store),
            allToolboxes: selectAllToolboxes(store),
            allQuals: selectAllQualifications(store),
        };
    },
    { getUsers, getToolboxTalks, getAllQualifications }
)(JobPackAssigneesArrayList);
